import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaExpand } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { galleryImages } from '../../data/hotelData';
import './Gallery.css';

const previewImages = galleryImages.slice(0, 8);

export default function Gallery({ limit = 8 }) {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section className="section gallery-section">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Our Gallery</span>
          <h2 className="section-title">Explore Grand Luxe</h2>
          <div className="gold-line" />
          <p className="section-subtitle">
            A visual journey through our exquisite spaces, world-class facilities, and breathtaking surroundings.
          </p>
        </div>

        <div className="gallery-grid">
          {previewImages.map((img, i) => (
            <motion.div
              key={img.id}
              className="gallery-item"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
            >
              <img src={img.src} alt={img.title} loading="lazy" />
              <div className="gallery-item-overlay">
                <button className="gallery-expand" onClick={() => setLightbox(img)}>
                  <FaExpand />
                </button>
                <span className="gallery-item-title">{img.title}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="gallery-cta">
          <Link to="/gallery" className="btn btn-outline">View Full Gallery</Link>
        </div>
      </div>

      <AnimatePresence>
        {lightbox && (
          <motion.div
            className="lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setLightbox(null)}
          >
            <motion.div
              className="lightbox-content"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              onClick={e => e.stopPropagation()}
            >
              <button className="lightbox-close" onClick={() => setLightbox(null)}>
                <FaTimes />
              </button>
              <img src={lightbox.src} alt={lightbox.title} />
              <p className="lightbox-caption">{lightbox.title}</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
